<div class="breadcrumbs">
  <div class="row">
    <div
      class="col-12 col-xl-10 mx-auto d-flex breadcrumbs-container align-items-center"
      *ngIf="brandShort"
    >
      <a class="mx-1" [routerLink]="'/' + brandShort"
        >{{ "start" | translate }}
      </a>
      <div>/</div>
      <ng-container *ngIf="breadcrumbs.length">
        <ng-container *ngFor="let breadcrumb of breadcrumbs; let i = index">
          <a
            [class.fw-bold]="i === breadcrumbs.length - 1 && !currentPage"
            *ngIf="breadcrumb.name"
            class="mx-1"
            [routerLink]="
              '/' +
              brandShort +
              '/category/' +
              breadcrumb.id +
              '/' +
              (breadcrumb.name | encodeURIComponent)
            "
          >
            {{ breadcrumb.name }}
          </a>
          <div *ngIf="i !== breadcrumbs.length - 1">/</div>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="currentPage">
        <div *ngIf="breadcrumbs.length">/</div>
        <a class="fw-bold mx-1 no-pointer">
          {{ currentPage }}
        </a>
      </ng-container>
    </div>
  </div>
</div>
